export const en = {
    'adjustments-rate': 'Bids shown are before adjustments',
    audience_coverage: 'Audience coverage',
    'context-click-price': 'CPC in ad networks',
    'context-price': 'Bid (in ad networks)',
    coverage: 'Coverage',
    'cpm-banner-set-context-price': 'Set CPM bid',
    'cpm-banner-title': 'Bid change',
    'no-display-info':
        "The forecast for coverage or CPC is not available because there isn't enough data for this keyword in ad networks (YAN and ad exchanges). "
};
